<template>
  <div :class="[{scrollable: !$store.state.isMobile}, {dropdowncontrol:isDropdownControlled}]">
    <span :class="['form-label',{ displayblock: isDisplayedBlock}]">{{ question }}</span>&nbsp;
      <b-dropdown aria-role="list" @input="questionAnswered" ref="dropdown" v-model="selected" :disabled="isDisabled"
                  :class="[{mandatory:isMandatory}, 'question-control']" :tabIndex="tab" :trap-focus="true"
                  @keyup.native.enter="enterIntoDropdown">
        <div slot="trigger" slot-scope="{ active }" class="select-choose">
          <span :class="selectedClass">{{selectedText}}</span>
          <b-icon :icon="active ? 'menu-up' : 'menu-down'"></b-icon>
        </div>

        <b-dropdown-item aria-role="listitem" v-for="option in options" v-bind:key="option.value" :value="option.value"
                         @keyup.native.enter="$event.currentTarget.click();">
          {{ option.displayText || option.text }}
        </b-dropdown-item>

      </b-dropdown>
    <span class="form-label">{{ closingSentence }}</span>
  </div>
</template>
<script>
/* eslint prefer-arrow-callback: "warn" */
export default {
  name: 'ChooseQuestion',
  props: {
    options: {
      type: Array,
      default() { return [{ value: 0, text: 'Loading' }]; },
    },
    question: String,
    closingSentence: String,
    isDisabled: Boolean,
    isMandatory: Boolean,
    isDropdownControlled: Boolean,
    isDisplayedBlock: Boolean,
    existingValue: { type: String, default: '' },
    tab: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    selectedText() {
      const option = this.options.find((o) => o.value === this.selected);

      return option ? option.displayText || option.text : 'Please Select';
    },
    selectedClass() {
      return {
        'select-placeholder': this.selectedText === 'Please Select',
        'select-value-selected': this.selectedText !== 'Please Select',
      };
    },
  },
  watch: {
    options: {
      immediate: true,
      handler() {
        if (this.options && this.options.length > 0 && this.options[0].text !== 'Loading' && this.existingValue !== '') {
          this.setSelectedFromExisting();
          this.questionAnswered();
        }
      },
    },
  },
  data() {
    return {
      selected: '',
    };
  },
  methods: {
    setSelectedFromExisting() {
      const existing = this.options.find((o) => o.text === this.existingValue);

      this.selected = existing ? existing.value : 'Please Select';
    },
    questionAnswered() {
      if (this.selected !== 'Please Select') {
        this.$emit('question-answered', this.options.find((o) => o.value === this.selected));
      }
    },
    enterIntoDropdown() {
      this.$refs.dropdown.toggle();
    },
    resetSelected() {
      this.selected = '';
    },
  },
};
</script>
